module.exports = __webpack_public_path__ + "media/images/svgs/checkmark-2a24d9c4ab30a537a218243d673adafc.svg";